export { default as EventDetails } from "./eventDetails";
export { default as EventInfo } from "./eventInfo";
